/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMvRefreshResultDto } from '../../models/backend-mv-refresh-result-dto';

export interface RefreshOneEndpointAdminRefreshNamePost$Params {
  name: string;
}

export function refreshOneEndpointAdminRefreshNamePost(
  http: HttpClient,
  rootUrl: string,
  params: RefreshOneEndpointAdminRefreshNamePost$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMvRefreshResultDto>> {
  const rb = new RequestBuilder(rootUrl, refreshOneEndpointAdminRefreshNamePost.PATH, 'post');
  if (params) {
    rb.path('name', params.name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMvRefreshResultDto>;
    }),
  );
}

refreshOneEndpointAdminRefreshNamePost.PATH = '/admin/refresh/{name}';
